// extracted by mini-css-extract-plugin
export default {"heading":"rt-z","corrected":"st-z","redirectVerbiageContainer":"tt-z","redirectVerbiageText":"ut-z"};